import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
// eslint-disable-next-line import/no-unresolved
import '@jem-open/jem-ui/styles.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import FeatureFlagProvider from "./utils/feature-flagging/FeatureFlagProvider";

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
     <FeatureFlagProvider>
        <App />
     </FeatureFlagProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
